let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iNITq")).then(() => parcelRequire('g4PUK'));